import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/activity/PartGroupingDecorator.module_built.css";
const classes = {"part-grouping-decorator--from-user":"w6hsPoW_part-grouping-decorator--from-user","variant-fluent":"w6hsPoW_variant-fluent","variant-copilot":"w6hsPoW_variant-copilot","part-grouping-decorator--group":"w6hsPoW_part-grouping-decorator--group","part-grouping-decorator--from-bot":"w6hsPoW_part-grouping-decorator--from-bot","part-grouping-decorator":"w6hsPoW_part-grouping-decorator"}
export default classes

const _part_grouping_decorator__from_user0 = classes["part-grouping-decorator--from-user"]
export { _part_grouping_decorator__from_user0 as "part-grouping-decorator--from-user" }

const _variant_fluent0 = classes["variant-fluent"]
export { _variant_fluent0 as "variant-fluent" }

const _variant_copilot0 = classes["variant-copilot"]
export { _variant_copilot0 as "variant-copilot" }

const _part_grouping_decorator__group0 = classes["part-grouping-decorator--group"]
export { _part_grouping_decorator__group0 as "part-grouping-decorator--group" }

const _part_grouping_decorator__from_bot0 = classes["part-grouping-decorator--from-bot"]
export { _part_grouping_decorator__from_bot0 as "part-grouping-decorator--from-bot" }

const _part_grouping_decorator0 = classes["part-grouping-decorator"]
export { _part_grouping_decorator0 as "part-grouping-decorator" }
